import dhtmlXTreeObject from './dhtmlXTreeObject';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';

dhtmlXTreeObject.prototype.setItemContextMenu = function (h, g) {
    var a = h.toString().split(this.dlmtr);
    for (var e = 0; e < a.length; e++) {
        var c = this._globalIdStorageFind(a[e]);
        if (!c) {
            continue;
        }
        c.cMenu = g;
    }
};
dhtmlXTreeObject.prototype.insertNewItem = function (g, n, r, e, m, l, h, c, a) {
    var s = this._globalIdStorageFind(g);
    if (!s) {
        return -1;
    }
    var o = this._attachChildNode(s, n, r, e, m, l, h, c, a);
    if (!this._idpull[this.rootId].XMLload) {
        this._idpull[this.rootId].XMLload = 1;
    }
    if (!this.XMLloadingWarning && this.childCalc) {
        this._fixChildCountLabel(s);
    }
    return o;
};
dhtmlXTreeObject.prototype.insertNewChild = function (g, n, o, e, m, l, h, c, a) {
    return this.insertNewItem(g, n, o, e, m, l, h, c, a);
};
dhtmlXTreeObject.prototype._parseXMLTree = function (a, e) {
    var c = new xmlPointer(dhx4.ajax.xmltop("tree", a));
    this._parse(c);
    this._p = c;
    if (e) {
        e.call(this, a);
    }
};
dhtmlXTreeObject.prototype._parseItem = function (l, r, h, n) {
    var e;
    if (this._srnd &&
        (!this._idpull[(e = l.get("id"))] || !this._idpull[e].span)) {
        this._addItemSRND(r.id, e, l);
        return;
    }
    var m = l.get_all();
    if (typeof this.waitUpdateXML == "object" && !this.waitUpdateXML[m.id]) {
        this._parse(l, m.id, 1);
        return;
    }
    if (m.text === null || typeof m.text == "undefined") {
        m.text = l.sub("itemtext");
        if (m.text) {
            m.text = m.text.content();
        }
    }
    var u = [];
    if (m.select) {
        u.push("SELECT");
    }
    if (m.top) {
        u.push("TOP");
    }
    if (m.call) {
        this.nodeAskingCall = m.id;
    }
    if (m.checked == -1) {
        u.push("HCHECKED");
    }
    else {
        if (m.checked) {
            u.push("CHECKED");
        }
    }
    if (m.open) {
        u.push("OPEN");
    }
    if (this.waitUpdateXML) {
        var o = null;
        if (this._globalIdStorageFind(m.id)) {
            o = this.updateItem(m.id, m.text, m.im0, m.im1, m.im2, m.checked, m.child);
        }
        else {
            if (this.npl == 0) {
                u.push("TOP");
            }
            else {
                h = r.childNodes[this.npl];
            }
            o = this._attachChildNode(r, m.id, m.text, 0, m.im0, m.im1, m.im2, u.join(","), m.child, 0, h);
            m.id = o.id;
            h = null;
        }
    }
    else {
        o = this._attachChildNode(r, m.id, m.text, 0, m.im0, m.im1, m.im2, u.join(","), m.child, n || 0, h);
    }
    if (m.tooltip) {
        o.span.parentNode.parentNode.title = m.tooltip;
    }
    if (m.style) {
        if (o.span.style.cssText) {
            o.span.style.cssText += ";" + m.style;
        }
        else {
            o.span.setAttribute("style", o.span.getAttribute("style") + "; " + m.style);
        }
    }
    if (m.radio) {
        o._r_logic = true;
    }
    if (m.nocheckbox) {
        var s = o.span.parentNode.previousSibling.previousSibling;
        s.style.display = "none";
        o.nocheckbox = true;
    }
    if (m.disabled) {
        if (m.checked != null) {
            this._setCheck(o, m.checked);
        }
        this.disableCheckbox(o, 1);
    }
    o._acc = m.child || 0;
    if (this.parserExtension) {
        this.parserExtension._parseExtension.call(this, l, m, r ? r.id : 0);
    }
    this.setItemColor(o, m.aCol, m.sCol);
    if (m.locked == "1") {
        this.lockItem(o.id, true, true);
    }
    if (m.imwidth || m.imheight) {
        this.setIconSize(m.imwidth, m.imheight, o);
    }
    if (m.closeable == "0" || m.closeable == "1") {
        this.setItemCloseable(o, m.closeable);
    }
    var g = "";
    if (m.topoffset) {
        this.setItemTopOffset(o, m.topoffset);
    }
    if (!this.slowParse || typeof this.waitUpdateXML == "object") {
        if (l.sub_exists("item")) {
            g = this._parse(l, m.id, 1);
        }
    }
    else {
        if (!o.childsCount && l.sub_exists("item")) {
            o.unParsed = l.clone();
        }
        l.each("userdata", function (a) {

            this.setUserData(m.id, a.get("name"), a.content());
        }, this);
    }
    if (g != "") {
        this.nodeAskingCall = g;
    }
    l.each("userdata", function (a) {

        this.setUserData(l.get("id"), a.get("name"), a.content());
    }, this);
};
dhtmlXTreeObject.prototype._parse = function (e, l, a, c) {
    if (this._srnd && !this.parentObject.offsetHeight) {
        var w = this;
        return window.setTimeout(function () {
            w._parse(e, l, a, c);
        }, 100);
    }
    if (!e.exists()) {
        return;
    }
    this.skipLock = true;
    if (!l) {
        l = e.get("id");
        if (this._dynDeleteBranches[l]) {
            this.deleteChildItems(l);
            this._dynDeleteBranches[l]--;
            if (!this._dynDeleteBranches[l]) {
                delete this._dynDeleteBranches[l];
            }
        }
        var u = e.get("dhx_security");
        if (u) {
            dhtmlx.security_key = u;
        }
        if (e.get("radio")) {
            this.htmlNode._r_logic = true;
        }
        this.parsingOn = l;
        this.parsedArray = new Array();
        this.setCheckList = "";
        this.nodeAskingCall = "";
    }
    var v = this._globalIdStorageFind(l);
    if (!v) {
        return dhx4.callEvent("onDataStructureError", [
            "XML refers to not existing parent"
        ]);
    }
    this.parsCount = this.parsCount ? this.parsCount + 1 : 1;
    this.XMLloadingWarning = 1;
    var m = null;
    if (v.childsCount && !c && !this._edsbps && !v._has_top) {
        m = 0;
    }
    else {
        m = 0;
    }
    this.npl = 0;
    e.each("item", function (x, n) {
        v.XMLload = 1;

        this._parseItem(x, v, 0, m);

        if (this._edsbps && this.npl == this._edsbpsC) {

            this._distributedStart(e, n + 1, l, a, v.childsCount);
            return -1;
        }

        this.npl++;
    }, this, c);
    if (!a) {
        e.each("userdata", function (n) {

            this.setUserData(e.get("id"), n.get("name"), n.content());
        }, this);
        v.XMLload = 1;
        if (this.waitUpdateXML) {
            this.waitUpdateXML = false;
            for (var h = v.childsCount - 1; h >= 0; h--) {
                if (v.childNodes[h]._dmark) {
                    this.deleteItem(v.childNodes[h].id);
                }
            }
        }
        this._globalIdStorageFind(this.parsingOn);
        for (var h_1 = 0; h_1 < this.parsedArray.length; h_1++) {
            v.htmlNode.childNodes[0].appendChild(this.parsedArray[h_1]);
        }
        this.parsedArray = [];
        this.lastLoadedXMLId = l;
        this.XMLloadingWarning = 0;
        var s = this.setCheckList.split(this.dlmtr);
        for (var g = 0; g < s.length; g++) {
            if (s[g]) {
                this.setCheck(s[g], 1);
            }
        }
        if (this.XMLsource && this.tscheck && this.smcheck && v.id != this.rootId) {
            if (v.checkstate === 0) {
                this._setSubChecked(0, v);
            }
            else {
                if (v.checkstate === 1) {
                    this._setSubChecked(1, v);
                }
            }
        }
        this._redrawFrom(this, null, c);
        if (e.get("order") && e.get("order") != "none") {
            this._reorderBranch(v, e.get("order"), true);
        }
        if (this.nodeAskingCall != "") {
            this.callEvent("onClick", [
                this.nodeAskingCall,
                this.getSelectedItemId()
            ]);
        }
        if (this._branchUpdate) {
            this._branchUpdateNext(e);
        }
    }
    if (this.parsCount == 1) {
        this.parsingOn = null;
        if (this._srnd && v.id != this.rootId) {
            this.prepareSR(v.id);
            if (this.XMLsource) {
                this.openItem(v.id);
            }
        }
        e.through("item", "open", null, function (n) {

            this.openItem(n.get("id"));
        }, this);
        if (!this._edsbps || !this._edsbpsA.length) {
            var o = this;
            window.setTimeout(function () {
                o.callEvent("onXLE", [o, l]);
            }, 1);
            this.xmlstate = 0;
        }
        this.skipLock = false;
    }
    this.parsCount--;
    o = this;
    if (this._edsbps) {
        window.setTimeout(function () {
            o._distributedStep(l);
        }, this._edsbpsD);
    }
    if (!a && this.onXLE) {
        this.onXLE(this, l);
    }
    return this.nodeAskingCall;
};
dhtmlXTreeObject.prototype._branchUpdateNext = function (a) {
    a.each("item", function (g) {
        var e = g.get("id");

        if (this._idpull[e] && !this._idpull[e].XMLload) {
            return;
        }

        this._branchUpdate++;

        this.smartRefreshItem(g.get("id"), g);
    }, this);
    this._branchUpdate--;
};
dhtmlXTreeObject.prototype.checkUserData = function (c, e) {
    if (c.nodeType == 1 && c.tagName == "userdata") {
        var a = c.getAttribute("name");
        if (a && c.childNodes[0]) {
            this.setUserData(e, a, c.childNodes[0].data);
        }
    }
};
dhtmlXTreeObject.prototype._redrawFrom = function (n, c, m, e) {
    if (!c) {
        var h = n._globalIdStorageFind(n.lastLoadedXMLId);
        n.lastLoadedXMLId = -1;
        if (!h) {
            return 0;
        }
    }
    else {
        h = c;
    }
    var l = 0;
    for (var g = m ? m - 1 : 0; g < h.childsCount; g++) {
        if (!this._branchUpdate || this._getOpenState(h) == 1) {
            if (!c || e == 1) {
                h.childNodes[g].htmlNode.parentNode.parentNode.style.display = "";
            }
        }
        if (h.childNodes[g].openMe == 1) {
            this._openItem(h.childNodes[g]);
            h.childNodes[g].openMe = 0;
        }
        n._redrawFrom(n, h.childNodes[g]);
        if (this.childCalc != null) {
            if (h.childNodes[g].unParsed ||
                (!h.childNodes[g].XMLload && this.XMLsource)) {
                if (h.childNodes[g]._acc) {
                    h.childNodes[g].span.innerHTML =
                        h.childNodes[g].label +
                            this.htmlcA +
                            h.childNodes[g]._acc +
                            this.htmlcB;
                }
                else {
                    h.childNodes[g].span.innerHTML = h.childNodes[g].label;
                }
            }
            var a = null;
            if (h.childNodes[g].childNodes.length && this.childCalc) {
                if (this.childCalc == 1) {
                    h.childNodes[g].span.innerHTML =
                        h.childNodes[g].label +
                            this.htmlcA +
                            h.childNodes[g].childsCount +
                            this.htmlcB;
                }
                if (this.childCalc == 2) {
                    a =
                        h.childNodes[g].childsCount - (h.childNodes[g].pureChilds || 0);
                    if (a) {
                        h.childNodes[g].span.innerHTML =
                            h.childNodes[g].label + this.htmlcA + a + this.htmlcB;
                    }
                    if (h.pureChilds) {
                        h.pureChilds++;
                    }
                    else {
                        h.pureChilds = 1;
                    }
                }
                if (this.childCalc == 3) {
                    h.childNodes[g].span.innerHTML =
                        h.childNodes[g].label +
                            this.htmlcA +
                            h.childNodes[g]._acc +
                            this.htmlcB;
                }
                if (this.childCalc == 4) {
                    a = h.childNodes[g]._acc;
                    if (a) {
                        h.childNodes[g].span.innerHTML =
                            h.childNodes[g].label + this.htmlcA + a + this.htmlcB;
                    }
                }
            }
            else {
                if (this.childCalc == 4) {
                    l++;
                }
            }
            l += h.childNodes[g]._acc;
            if (this.childCalc == 3) {
                l++;
            }
        }
    }
    if (!h.unParsed && (h.XMLload || !this.XMLsource)) {
        h._acc = l;
    }
    n._correctLine(h);
    n._correctPlus(h);
    if (this.childCalc && !c) {
        n._fixChildCountLabel(h);
    }
};
dhtmlXTreeObject.prototype._createSelf = function () {
    var a = document.createElement("div");
    a.className = "containerTableStyle";
    a.style.width = this.width;
    a.style.height = this.height;
    this.parentObject.appendChild(a);
    return a;
};
dhtmlXTreeObject.prototype._xcloseAll = function (c) {
    if (c.unParsed) {
        return;
    }
    if (this.rootId != c.id) {
        if (!c.htmlNode) {
            return;
        }
        var g = c.htmlNode.childNodes[0].childNodes;
        var a = g.length;
        for (var e = 1; e < a; e++) {
            g[e].style.display = "none";
        }
        this._correctPlus(c);
    }
    for (var e_1 = 0; e_1 < c.childsCount; e_1++) {
        if (c.childNodes[e_1].childsCount) {
            this._xcloseAll(c.childNodes[e_1]);
        }
    }
};
dhtmlXTreeObject.prototype._xopenAll = function (a,openSon=true) {
    if(this.openMaxLevel==null){
        this.openMaxLevel=10;
    }
    if(this.openLevel==null){
        this.openLevel=0;
    }
    ++this.openLevel;
    this._HideShow(a, 2);
    if(openSon){
        for (var c = 0; c < a.childsCount; c++) {
            if(this.openLevel<this.openMaxLevel){
                this._xopenAll(a.childNodes[c],openSon);
            }
        }
    }

};
dhtmlXTreeObject.prototype._correctPlus = function (c) {
    if (!c.htmlNode) {
        return;
    }
    var e = c.htmlNode.childNodes[0].childNodes[0].childNodes[0].lastChild;
    var h = c.htmlNode.childNodes[0].childNodes[0].childNodes[2].childNodes[0];
    var a = this.lineArray;
    if (this.XMLsource && !c.XMLload) {
        a = this.plusArray;
        this._setSrc(h, this.iconURL + c.images[2]);
        if (this._txtimg) {
            return (e.innerHTML = "[+]");
        }
    }
    else {
        if (c.childsCount || c.unParsed) {
            if (c.htmlNode.childNodes[0].childNodes[1] &&
                c.htmlNode.childNodes[0].childNodes[1].style.display != "none") {
                if (!c.wsign) {
                    a = this.minusArray;
                }
                this._setSrc(h, this.iconURL + c.images[1]);
                if (this._txtimg) {
                    return (e.innerHTML = "[-]");
                }
            }
            else {
                if (!c.wsign) {
                    a = this.plusArray;
                }
                this._setSrc(h, this.iconURL + c.images[2]);
                if (this._txtimg) {
                    return (e.innerHTML = "[+]");
                }
            }
        }
        else {
            this._setSrc(h, this.iconURL + c.images[0]);
        }
    }
    var g = 2;
    if (!c.treeNod.treeLinesOn) {
        this._setSrc(e, this.imPath + a[3]);
    }
    else {
        if (c.parentObject) {
            g = this._getCountStatus(c.id, c.parentObject);
        }
        this._setSrc(e, this.imPath + a[g]);
    }
};
dhtmlXTreeObject.prototype._correctLine = function (c) {
    if (!c.htmlNode) {
        return;
    }
    var a = c.parentObject;
    if (a) {
        if (this._getLineStatus(c.id, a) == 0 || !this.treeLinesOn) {
            for (var e = 1; e <= c.childsCount; e++) {
                if (!c.htmlNode.childNodes[0].childNodes[e]) {
                    break;
                }
                c.htmlNode.childNodes[0].childNodes[e].childNodes[0].style.backgroundImage = "";
                c.htmlNode.childNodes[0].childNodes[e].childNodes[0].style.backgroundRepeat = "";
            }
        }
        else {
            for (var e1 = 1; e1 <= c.childsCount; e1++) {
                if (!c.htmlNode.childNodes[0].childNodes[e1]) {
                    break;
                }
                c.htmlNode.childNodes[0].childNodes[e1].childNodes[0].style.backgroundImage =
                    "url(" + this.imPath + this.lineArray[5] + ")";
                c.htmlNode.childNodes[0].childNodes[e1].childNodes[0].style.backgroundRepeat = "repeat-y";
            }
        }
    }
};
dhtmlXTreeObject.prototype._getCountStatus = function (c, a) {
    if (a.childsCount <= 1) {
        if (a.id == this.rootId) {
            return 4;
        }
        else {
            return 0;
        }
    }
    if (a.childNodes[0].id == c) {
        if (a.id == this.rootId) {
            return 2;
        }
        else {
            return 1;
        }
    }
    if (a.childNodes[a.childsCount - 1].id == c) {
        return 0;
    }
    return 1;
};
dhtmlXTreeObject.prototype._getLineStatus = function (c, a) {
    if (a.childNodes[a.childsCount - 1].id == c) {
        return 0;
    }
    return 1;
};
dhtmlXTreeObject.prototype._HideShow = function (c, h) {
    if (this._locker && !this.skipLock && this._locker[c.id]) {
        return;
    }
    if (this.XMLsource && !c.XMLload) {
        if (h == 1) {
            return;
        }
        c.XMLload = 1;
        this._loadDynXML(c.id);
        return;
    }
    if (c.unParsed) {
        this.reParse(c);
    }
    var g = c.htmlNode.childNodes[0].childNodes;
    var a = g.length;
    var nodestyle = null;
    if (a > 1) {
        if ((g[1].style.display != "none" || h == 1) && h != 2) {
            this.allTree.childNodes[0].border = "1";
            this.allTree.childNodes[0].border = "0";
            nodestyle = "none";
        }
        else {
            nodestyle = "";
        }
        for (var e = 1; e < a; e++) {
            g[e].style.display = nodestyle;
        }
    }
    this._correctPlus(c);
};
dhtmlXTreeObject.prototype._getOpenState = function (a) {
    if (!a.htmlNode) {
        return 0;
    }
    var c = a.htmlNode.childNodes[0].childNodes;
    if (c.length <= 1) {
        return 0;
    }
    if (c[1].style.display != "none") {
        return 1;
    }
    else {
        return -1;
    }
};
dhtmlXTreeObject.prototype.onRowClick2 = function () {
    var a = this.parentObject.treeNod;
    if (!a.callEvent("onDblClick", [this.parentObject.id, a])) {
        return false;
    }
    if (this.parentObject.closeble && this.parentObject.closeble != "0") {
        a._HideShow(this.parentObject);
    }
    else {
        a._HideShow(this.parentObject, 2);
    }
    if (a.checkEvent("onOpenEnd")) {
        if (!a.xmlstate) {
            a.callEvent("onOpenEnd", [
                this.parentObject.id,
                a._getOpenState(this.parentObject)
            ]);
        }
        else {
            a._oie_onXLE.push(a.onXLE);
            a.onXLE = a._epnFHe;
        }
    }
    return false;
};
dhtmlXTreeObject.prototype.onRowClick = function () {
    var a = this.parentObject.treeNod;
    if (!a.callEvent("onOpenStart", [
        this.parentObject.id,
        a._getOpenState(this.parentObject)
    ])) {
        return 0;
    }
    if (this.parentObject.closeble && this.parentObject.closeble != "0") {
        a._HideShow(this.parentObject);
    }
    else {
        a._HideShow(this.parentObject, 2);
    }
    if (a.checkEvent("onOpenEnd")) {
        if (!a.xmlstate) {
            a.callEvent("onOpenEnd", [
                this.parentObject.id,
                a._getOpenState(this.parentObject)
            ]);
        }
        else {
            a._oie_onXLE.push(a.onXLE);
            a.onXLE = a._epnFHe;
        }
    }
};
dhtmlXTreeObject.prototype._epnFHe = function (c, e, a) {
    if (e != this.rootId) {
        this.callEvent("onOpenEnd", [e, c.getOpenState(e)]);
    }
    c.onXLE = c._oie_onXLE.pop();
    if (!a && !c._oie_onXLE.length) {
        if (c.onXLE) {
            c.onXLE(c, e);
        }
    }
};
dhtmlXTreeObject.prototype.onRowClickDown = function (c) {
    c = c || window.event;
    var a = this.parentObject.treeNod;
    a._selectItem(this.parentObject, c);
};
dhtmlXTreeObject.prototype.getSelectedItemId = function () {
    var c = new Array();
    for (var a = 0; a < this._selected.length; a++) {
        c[a] = this._selected[a].id;
    }
    return c.join(this.dlmtr);
};
dhtmlXTreeObject.prototype._selectItem = function (m, n) {
    if (this.checkEvent("onSelect")) {
        this._onSSCFold = this.getSelectedItemId();
    }
    if (!this._amsel || !n || (!n.ctrlKey && !n.metaKey && !n.shiftKey)) {
        this._unselectItems();
    }
    if (m.i_sel && this._amsel && n && (n.ctrlKey || n.metaKey)) {
        this._unselectItem(m);
    }
    else {
        if (!m.i_sel &&
            (!this._amselS ||
                this._selected.length == 0 ||
                this._selected[0].parentObject == m.parentObject)) {
            if (this._amsel &&
                n &&
                n.shiftKey &&
                this._selected.length != 0 &&
                this._selected[this._selected.length - 1].parentObject == m.parentObject) {
                var h = this._getIndex(this._selected[this._selected.length - 1]);
                var g = this._getIndex(m);
                if (g < h) {
                    var r = h;
                    h = g;
                    g = r;
                }
                for (var l = h; l <= g; l++) {
                    if (!m.parentObject.childNodes[l].i_sel) {
                        this._markItem(m.parentObject.childNodes[l]);
                    }
                }
            }
            else {
                this._markItem(m);
            }
        }
    }
    if (this.checkEvent("onSelect")) {
        var o = this.getSelectedItemId();
        if (o != this._onSSCFold) {
            this.callEvent("onSelect", [o]);
        }
    }
};
dhtmlXTreeObject.prototype._markItem = function (a) {
    if (a.scolor) {
        a.span.style.color = a.scolor;
    }
    a.span.className = "selectedTreeRow";
    a.span.parentNode.parentNode.className = "selectedTreeRowFull";
    a.i_sel = true;
    this._selected[this._selected.length] = a;
};
dhtmlXTreeObject.prototype.getIndexById = function (c) {
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return null;
    }
    return this._getIndex(a);
};
dhtmlXTreeObject.prototype._getIndex = function (a) {
    var e = a.parentObject;
    for (var c = 0; c < e.childsCount; c++) {
        if (e.childNodes[c] == a) {
            return c;
        }
    }
};
dhtmlXTreeObject.prototype._unselectItem = function (c) {
    if (c && c.i_sel) {
        c.span.className = "standartTreeRow";
        c.span.parentNode.parentNode.className = "";
        if (c.acolor) {
            c.span.style.color = c.acolor;
        }
        c.i_sel = false;
        for (var a = 0; a < this._selected.length; a++) {
            if (!this._selected[a].i_sel) {
                this._selected.splice(a, 1);
                break;
            }
        }
    }
};
dhtmlXTreeObject.prototype._unselectItems = function () {
    for (var a = 0; a < this._selected.length; a++) {
        var c = this._selected[a];
        c.span.className = "standartTreeRow";
        c.span.parentNode.parentNode.className = "";
        if (c.acolor) {
            c.span.style.color = c.acolor;
        }
        c.i_sel = false;
    }
    this._selected = new Array();
};
dhtmlXTreeObject.prototype.onRowSelect = function (h, g, m) {
    h = h || window.event;
    var c = this.parentObject;
    if (g) {
        c = g.parentObject;
    }
    var a = c.treeNod;
    var l = a.getSelectedItemId();
    if (!h || !h.skipUnSel) {
        a._selectItem(c, h);
    }
    if (!m) {
        if (c.actionHandler) {
            c.actionHandler(c.id, l);
        }
        else {
            a.callEvent("onClick", [c.id, l]);
        }
    }
};
dhtmlXTreeObject.prototype._correctCheckStates = function (h) {
    if (!this.tscheck) {
        return;
    }
    if (!h) {
        return;
    }
    if (h.id == this.rootId) {
        return;
    }
    var e = h.childNodes;
    var c = 0;
    var a = 0;
    if (h.childsCount == 0) {
        return;
    }
    for (var g = 0; g < h.childsCount; g++) {
        if (e[g].dscheck) {
            continue;
        }
        if (e[g].checkstate == 0) {
            c = 1;
        }
        else {
            if (e[g].checkstate == 1) {
                a = 1;
            }
            else {
                c = 1;
                a = 1;
                break;
            }
        }
    }
    if (c && a) {
        this._setCheck(h, "unsure");
    }
    else {
        if (c) {
            this._setCheck(h, false);
        }
        else {
            this._setCheck(h, true);
        }
    }
    this._correctCheckStates(h.parentObject);
};
dhtmlXTreeObject.prototype.onCheckBoxClick = function () {
    if (!this.treeNod.callEvent("onBeforeCheck", [
        this.parentObject.id,
        this.parentObject.checkstate
    ])) {
        return;
    }
    if (this.parentObject.dscheck) {
        return true;
    }
    if (this.treeNod.tscheck) {
        if (this.parentObject.checkstate == 1) {
            this.treeNod._setSubChecked(false, this.parentObject);
        }
        else {
            this.treeNod._setSubChecked(true, this.parentObject);
        }
    }
    else {
        if (this.parentObject.checkstate == 1) {
            this.treeNod._setCheck(this.parentObject, false);
        }
        else {
            this.treeNod._setCheck(this.parentObject, true);
        }
    }
    this.treeNod._correctCheckStates(this.parentObject.parentObject);
    return this.treeNod.callEvent("onCheck", [
        this.parentObject.id,
        this.parentObject.checkstate
    ]);
};
dhtmlXTreeObject.prototype._createItem = function (u, s, n) {
    var v = document.createElement("table");
    v.cellSpacing = 0;
    v.cellPadding = 0;
    v.border = 0;
    if (this.hfMode) {
        v.style.tableLayout = "fixed";
    }
    v.style.margin = 0;
    v.style.padding = 0;
    var m = document.createElement("tbody");
    var r = document.createElement("tr");
    var g = document.createElement("td");
    g.className = "standartTreeImage";
    var h = null;
    if (this._txtimg) {
        h = document.createElement("div");
        g.appendChild(h);
        h.className = "dhx_tree_textSign";
    }
    else {
        h = this._getImg(s.id);
        h.border = "0";
        if (h.tagName == "IMG") {
            h.align = "absmiddle";
        }
        g.appendChild(h);
        h.style.padding = 0;
        h.style.margin = 0;
        h.style.width = this.def_line_img_x;
    }
    var e = document.createElement("td");
    var o = this._getImg(this.cBROf ? this.rootId : s.id);
    o.checked = 0;
    this._setSrc(o, this.imPath + this.checkArray[0]);
    o.style.width = "18px";
    o.style.height = "18px";
    if (!u) {
        e.style.display = "none";
    }
    e.appendChild(o);
    if (!this.cBROf && o.tagName == "IMG") {
        o.align = "absmiddle";
    }
    o.onclick = this.onCheckBoxClick;
    o.treeNod = this;
    o.parentObject = s;
    if (!window._KHTMLrv) {
        e.width = "20px";
    }
    else {
        e.width = "16px";
    }
    var c = document.createElement("td");
    c.className = "standartTreeImage";
    var l = this._getImg(this.timgen ? s.id : this.rootId);
    l.onmousedown = this._preventNsDrag;
    l.ondragstart = this._preventNsDrag;
    l.border = "0";
    if (this._aimgs) {
        l.parentObject = s;
        if (l.tagName == "IMG") {
            l.align = "absmiddle";
        }
        l.onclick = this.onRowSelect;
    }
    if (!n) {
        this._setSrc(l, this.iconURL + this.imageArray[0]);
    }
    c.appendChild(l);
    l.style.padding = 0;
    l.style.margin = 0;
    if (this.timgen) {
        c.style.width = l.style.width = this.def_img_x;
        l.style.height = this.def_img_y;
    }
    else {
        l.style.width = "0px";
        l.style.height = "0px";
        if (window._isOpera || window._KHTMLrv) {
            c.style.display = "none";
        }
    }
    var a = document.createElement("td");
    a.className = "dhxTextCell standartTreeRow";
    s.span = document.createElement("span");
    s.span.className = "standartTreeRow";
    if (this.mlitems) {
        s.span.style.width = this.mlitems;
        s.span.style.display = "block";
    }
    else {
        a.noWrap = true;
    }
    if (dhx4.isIE8) {
        a.style.width = "99999px";
    }
    else {
        // if (!window._KHTMLrv) {
        //     a.style.width = "100%";
        // }
    }
    s.span.innerHTML = s.label;
    a.appendChild(s.span);
    a.parentObject = s;
    g.parentObject = s;
    a.onclick = this.onRowSelect;
    g.onclick = this.onRowClick;
    a.ondblclick = this.onRowClick2;
    if (this.ettip) {
        r.title = s.label;
    }
    if (this.dragAndDropOff) {
        if (this._aimgs) {
            this.dragger.addDraggableItem(c, this);
            c.parentObject = s;
        }
        this.dragger.addDraggableItem(a, this);
    }
    s.span.style.paddingLeft = "5px";
    s.span.style.paddingRight = "5px";
    a.style.verticalAlign = "";
    a.style.fontSize = "10pt";
    a.style.cursor = this.style_pointer;
    r.appendChild(g);
    r.appendChild(e);
    r.appendChild(c);
    r.appendChild(a);
    m.appendChild(r);
    v.appendChild(m);
    if (this.ehlt ||
        this.checkEvent("onMouseIn") ||
        this.checkEvent("onMouseOut")) {
        r.onmousemove = this._itemMouseIn;
        r[window._isIE ? "onmouseleave" : "onmouseout"] = this._itemMouseOut;
    }
    return v;
};
dhtmlXTreeObject.prototype.setImagePath = function (a) {
    this.imPath = a;
    this.iconURL = a;
};
dhtmlXTreeObject.prototype.setIconPath = function (a) {
    this.iconURL = a;
};
dhtmlXTreeObject.prototype._getLeafCount = function (g) {
    var e = 0;
    for (var c = 0; c < g.childsCount; c++) {
        if (g.childNodes[c].childsCount == 0) {
            e++;
        }
    }
    return e;
};
dhtmlXTreeObject.prototype._getChildCounterValue = function (c) {
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return 0;
    }
    if (a.unParsed || (!a.XMLload && this.XMLsource)) {
        return a._acc;
    }
    switch (this.childCalc) {
        case 1:
            return a.childsCount;
        case 2:
            return this._getLeafCount(a);
        case 3:
            return a._acc;
        case 4:
            return a._acc;
    }
};
dhtmlXTreeObject.prototype._fixChildCountLabel = function (l) {
    if (this.childCalc == null) {
        return;
    }
    if (l.unParsed || (!l.XMLload && this.XMLsource)) {
        if (l._acc) {
            l.span.innerHTML = l.label + this.htmlcA + l._acc + this.htmlcB;
        }
        else {
            l.span.innerHTML = l.label;
        }
        return;
    }
    switch (this.childCalc) {
        case 1:
            if (l.childsCount != 0) {
                l.span.innerHTML = l.label + this.htmlcA + l.childsCount + this.htmlcB;
            }
            else {
                l.span.innerHTML = l.label;
            }
            break;
        case 2:
            var h = this._getLeafCount(l);
            if (h != 0) {
                l.span.innerHTML = l.label + this.htmlcA + h + this.htmlcB;
            }
            else {
                l.span.innerHTML = l.label;
            }
            break;
        case 3:
            if (l.childsCount != 0) {
                var e = 0;
                for (var c = 0; c < l.childsCount; c++) {
                    if (!l.childNodes[c]._acc) {
                        l.childNodes[c]._acc = 0;
                    }
                    e += l.childNodes[c]._acc * 1;
                }
                e += l.childsCount * 1;
                l.span.innerHTML = l.label + this.htmlcA + e + this.htmlcB;
                l._acc = e;
            }
            else {
                l.span.innerHTML = l.label;
                l._acc = 0;
            }
            if (l.parentObject && l.parentObject != this.htmlNode) {
                this._fixChildCountLabel(l.parentObject);
            }
            break;
        case 4:
            if (l.childsCount != 0) {
                var eEL = 0;
                for (var c_1 = 0; c_1 < l.childsCount; c_1++) {
                    if (!l.childNodes[c_1]._acc) {
                        l.childNodes[c_1]._acc = 1;
                    }
                    eEL += l.childNodes[c_1]._acc * 1;
                }
                l.span.innerHTML = l.label + this.htmlcA + eEL + this.htmlcB;
                l._acc = eEL;
            }
            else {
                l.span.innerHTML = l.label;
                l._acc = 1;
            }
            if (l.parentObject && l.parentObject != this.htmlNode) {
                this._fixChildCountLabel(l.parentObject);
            }
            break;
    }
};
dhtmlXTreeObject.prototype.setChildCalcMode = function (a) {
    switch (a) {
        case "child":
            this.childCalc = 1;
            break;
        case "leafs":
            this.childCalc = 2;
            break;
        case "childrec":
            this.childCalc = 3;
            break;
        case "leafsrec":
            this.childCalc = 4;
            break;
        case "disabled":
            this.childCalc = null;
            break;
        default:
            this.childCalc = 4;
    }
};
dhtmlXTreeObject.prototype.setChildCalcHTML = function (c, a) {
    this.htmlcA = c;
    this.htmlcB = a;
};
dhtmlXTreeObject.prototype.setOnRightClickHandler = function (a) {
    this.attachEvent("onRightClick", a);
};
dhtmlXTreeObject.prototype.setOnClickHandler = function (a) {
    this.attachEvent("onClick", a);
};
dhtmlXTreeObject.prototype.setOnSelectStateChange = function (a) {
    this.attachEvent("onSelect", a);
};
dhtmlXTreeObject.prototype.setXMLAutoLoading = function (a) {
    this.XMLsource = a;
};
dhtmlXTreeObject.prototype.setOnCheckHandler = function (a) {
    this.attachEvent("onCheck", a);
};
dhtmlXTreeObject.prototype.setOnOpenHandler = function (a) {
    this.attachEvent("onOpenStart", a);
};
dhtmlXTreeObject.prototype.setOnOpenStartHandler = function (a) {
    this.attachEvent("onOpenStart", a);
};
dhtmlXTreeObject.prototype.setOnOpenEndHandler = function (a) {
    this.attachEvent("onOpenEnd", a);
};
dhtmlXTreeObject.prototype.setOnDblClickHandler = function (a) {
    this.attachEvent("onDblClick", a);
};
dhtmlXTreeObject.prototype.openAllItems = function (c) {
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return 0;
    }
    this._xopenAll(a);
};
dhtmlXTreeObject.prototype.getOpenState = function (c) {
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return "";
    }
    return this._getOpenState(a);
};
dhtmlXTreeObject.prototype.closeAllItems = function (c) {
    if (c === window.undefined) {
        c = this.rootId;
    }
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return 0;
    }
    this._xcloseAll(a);
    this.allTree.childNodes[0].border = "1";
    this.allTree.childNodes[0].border = "0";
};
dhtmlXTreeObject.prototype.setUserData = function (g, c, e) {
    var a = this._globalIdStorageFind(g, 0, true);
    if (!a) {
        return;
    }
    if (c == "hint") {
        a.htmlNode.childNodes[0].childNodes[0].title = e;
    }
    if (typeof a.userData["t_" + c] == "undefined") {
        if (!a._userdatalist) {
            a._userdatalist = c;
        }
        else {
            a._userdatalist += "," + c;
        }
    }
    a.userData["t_" + c] = e;
};
dhtmlXTreeObject.prototype.getUserData = function (e, c) {
    var a = this._globalIdStorageFind(e, 0, true);
    if (!a) {
        return;
    }
    return a.userData["t_" + c];
};
dhtmlXTreeObject.prototype.getItemColor = function (e) {
    var a = this._globalIdStorageFind(e);
    if (!a) {
        return 0;
    }
    var c = new Object();
    if (a.acolor) {
        c.acolor = a.acolor;
    }
    if (a.scolor) {
        c.scolor = a.scolor;
    }
    return c;
};
dhtmlXTreeObject.prototype.setItemColor = function (e, c, g) {
    var a = null;
    if (e && e.span) {
        a = e;
    }
    else {
        a = this._globalIdStorageFind(e);
    }
    if (!a) {
        return 0;
    }
    else {
        if (a.i_sel) {
            if (g || c) {
                a.span.style.color = g || c;
            }
        }
        else {
            if (c) {
                a.span.style.color = c;
            }
        }
        if (g) {
            a.scolor = g;
        }
        if (c) {
            a.acolor = c;
        }
    }
};
dhtmlXTreeObject.prototype.getItemText = function (c) {
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return 0;
    }
    return a.htmlNode.childNodes[0].childNodes[0].childNodes[3].childNodes[0]
        .innerHTML;
};
dhtmlXTreeObject.prototype.getParentId = function (c) {
    var a = this._globalIdStorageFind(c);
    if (!a || !a.parentObject) {
        return "";
    }
    return a.parentObject.id;
};
dhtmlXTreeObject.prototype.changeItemId = function (c, e) {
    if (c == e) {
        return;
    }
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return 0;
    }
    a.id = e;
    a.span.contextMenuId = e;
    this._idpull[e] = this._idpull[c];
    delete this._idpull[c];
};
dhtmlXTreeObject.prototype.doCut = function () {
    if (this.nodeCut) {
        this.clearCut();
    }
    this.nodeCut = new Array().concat(this._selected);
    for (var a = 0; a < this.nodeCut.length; a++) {
        var c = this.nodeCut[a];
        c._cimgs = new Array();
        c._cimgs[0] = c.images[0];
        c._cimgs[1] = c.images[1];
        c._cimgs[2] = c.images[2];
        c.images[0] = c.images[1] = c.images[2] = this.cutImage;
        this._correctPlus(c);
    }
};
dhtmlXTreeObject.prototype.doPaste = function (e) {
    var a = this._globalIdStorageFind(e);
    if (!a) {
        return 0;
    }
    for (var c = 0; c < this.nodeCut.length; c++) {
        if (this._checkPNodes(a, this.nodeCut[c])) {
            continue;
        }
        this._moveNode(this.nodeCut[c], a);
    }
    this.clearCut();
};
dhtmlXTreeObject.prototype.clearCut = function () {
    for (var a = 0; a < this.nodeCut.length; a++) {
        var c = this.nodeCut[a];
        c.images[0] = c._cimgs[0];
        c.images[1] = c._cimgs[1];
        c.images[2] = c._cimgs[2];
        this._correctPlus(c);
    }
    this.nodeCut = new Array();
};
dhtmlXTreeObject.prototype._moveNode = function (a, c) {
    var l = this.dadmodec;
    if (l == 1) {
        var h = c;
        if (this.dadmodefix < 0) {
            while (true) {
                h = this._getPrevNode(h);
                if (h == -1) {
                    h = this.htmlNode;
                    break;
                }
                if (h.tr == 0 || h.tr.style.display == "" || !h.parentObject) {
                    break;
                }
            }
            var g = h;
            var e = c;
        }
        else {
            if (h.tr &&
                h.tr.nextSibling &&
                h.tr.nextSibling.nodem &&
                this._getOpenState(h) < 1) {
                h = h.tr.nextSibling.nodem;
            }
            else {
                if (this._getOpenState(h) < 1) {
                    h = this.htmlNode;
                }
                else {
                    h = this._getNextNode(h);
                    if (h == -1) {
                        h = this.htmlNode;
                    }
                }
            }
            var e = h;
            var g = c;
        }
        if (this._getNodeLevel(g, 0) > this._getNodeLevel(e, 0)) {
            if (!this.dropLower) {
                return this._moveNodeTo(a, g.parentObject);
            }
            else {
                if (e.id != this.rootId) {
                    return this._moveNodeTo(a, e.parentObject, e);
                }
                else {
                    return this._moveNodeTo(a, this.htmlNode, null);
                }
            }
        }
        else {
            return this._moveNodeTo(a, e.parentObject, e);
        }
    }
    else {
        return this._moveNodeTo(a, c);
    }
};
dhtmlXTreeObject.prototype._fixNodesCollection = function (n, l) {
    var c = 0;
    var g = 0;
    var m = n.childNodes;
    var a = n.childsCount - 1;
    if (l == m[a]) {
        return;
    }
    for (var h = 0; h < a; h++) {
        if (m[h] == m[a]) {
            m[h] = m[h + 1];
            m[h + 1] = m[a];
        }
    }
    for (var h1 = 0; h1 < a + 1; h1++) {
        if (c) {
            var e = m[h1];
            m[h1] = c;
            c = e;
        }
        else {
            if (m[h1] == l) {
                c = m[h1];
                m[h1] = m[a];
            }
        }
    }
};
dhtmlXTreeObject.prototype._recreateBranch = function (l, n, h, a) {
    var c;
    var o = "";
    if (h) {
        for (c = 0; c < n.childsCount; c++) {
            if (n.childNodes[c] == h) {
                break;
            }
        }
        if (c != 0) {
            h = n.childNodes[c - 1];
        }
        else {
            o = "TOP";
            h = "";
        }
    }
    var e = this._onradh;
    this._onradh = null;
    var m = this._attachChildNode(n, l.id, l.label, 0, l.images[0], l.images[1], l.images[2], o, 0, h);
    m._userdatalist = l._userdatalist;
    m.userData = l.userData.clone();
    if (l._attrs) {
        m._attrs = {};
        for (var g in l._attrs) {
            m._attrs[g] = l._attrs[g];
        }
    }
    m.XMLload = l.XMLload;
    if (e) {
        this._onradh = e;
        this._onradh(m.id);
    }
    if (l.treeNod.dpcpy) {
        l.treeNod._globalIdStorageFind(l.id);
    }
    else {
        m.unParsed = l.unParsed;
    }
    this._correctPlus(m);
    for (var c_2 = 0; c_2 < l.childsCount; c_2++) {
        this._recreateBranch(l.childNodes[c_2], m, 0, 1);
    }
    if (!a && this.childCalc) {
        this._redrawFrom(this, n);
    }
    return m;
};
dhtmlXTreeObject.prototype._moveNodeTo = function (u, w, s) {
    if (u.treeNod._nonTrivialNode) {
        return u.treeNod._nonTrivialNode(this, w, s, u);
    }
    if (this._checkPNodes(w, u)) {
        return false;
    }
    var m = null;
    if (w.mytype) {
        m = u.treeNod.lWin != w.lWin;
    }
    else {
        m = u.treeNod.lWin != w.treeNod.lWin;
    }
    if (!this.callEvent("onDrag", [
        u.id,
        w.id,
        s ? s.id : null,
        u.treeNod,
        w.treeNod
    ])) {
        return false;
    }
    if (w.XMLload == 0 && this.XMLsource) {
        w.XMLload = 1;
        this._loadDynXML(w.id);
    }
    this.openItem(w.id);
    var e = u.treeNod;
    var o = u.parentObject.childsCount;
    var r = u.parentObject;
    if (m || e.dpcpy) {
        var g = u.id;
        u = this._recreateBranch(u, w, s);
        if (!e.dpcpy) {
            e.deleteItem(g);
        }
    }
    else {
        var h = w.childsCount;
        var v = w.childNodes;
        if (h == 0) {
            w._open = true;
        }
        e._unselectItem(u);
        v[h] = u;
        u.treeNod = w.treeNod;
        w.childsCount++;
        var n = this._drawNewTr(v[h].htmlNode);
        if (!s) {
            w.htmlNode.childNodes[0].appendChild(n);
            if (this.dadmode == 1) {
                this._fixNodesCollection(w, s);
            }
        }
        else {
            w.htmlNode.childNodes[0].insertBefore(n, s.tr);
            this._fixNodesCollection(w, s);
            v = w.childNodes;
        }
    }
    if (!e.dpcpy && !m) {
        var a = u.tr;
        if (document.all && navigator.appVersion.search(/MSIE\ 5\.0/gi) != -1) {
            window.setTimeout(function () {
                a.parentNode.removeChild(a);
            }, 250);
        }
        else {
            u.parentObject.htmlNode.childNodes[0].removeChild(u.tr);
        }
        if (!s || w != u.parentObject) {
            for (var l = 0; l < r.childsCount; l++) {
                if (r.childNodes[l].id == u.id) {
                    r.childNodes[l] = 0;
                    break;
                }
            }
        }
        else {
            r.childNodes[r.childsCount - 1] = 0;
        }
        e._compressChildList(r.childsCount, r.childNodes);
        r.childsCount--;
    }
    if (!m && !e.dpcpy) {
        u.tr = n;
        n.nodem = u;
        u.parentObject = w;
        if (e != w.treeNod) {
            if (u.treeNod._registerBranch(u, e)) {
                return;
            }
            this._clearStyles(u);
            this._redrawFrom(this, u.parentObject);
            if (this._onradh) {
                this._onradh(u.id);
            }
        }
        this._correctPlus(w);
        this._correctLine(w);
        this._correctLine(u);
        this._correctPlus(u);
        if (s) {
            this._correctPlus(s);
        }
        else {
            if (w.childsCount >= 2) {
                this._correctPlus(v[w.childsCount - 2]);
                this._correctLine(v[w.childsCount - 2]);
            }
        }
        this._correctPlus(v[w.childsCount - 1]);
        if (this.tscheck) {
            this._correctCheckStates(w);
        }
        if (e.tscheck) {
            e._correctCheckStates(r);
        }
    }
    if (o > 1) {
        e._correctPlus(r.childNodes[o - 2]);
        e._correctLine(r.childNodes[o - 2]);
    }
    e._correctPlus(r);
    e._correctLine(r);
    this._fixChildCountLabel(w);
    e._fixChildCountLabel(r);
    this.callEvent("onDrop", [u.id, w.id, s ? s.id : null, e, w.treeNod]);
    return u.id;
};
dhtmlXTreeObject.prototype._clearStyles = function (a) {
    if (!a.htmlNode) {
        return;
    }
    var g = a.htmlNode.childNodes[0].childNodes[0].childNodes[1];
    var c = g.nextSibling.nextSibling;
    a.span.innerHTML = a.label;
    a.i_sel = false;
    if (a._aimgs) {
        this.dragger.removeDraggableItem(g.nextSibling);
    }
    if (this.checkBoxOff) {
        g.childNodes[0].style.display = "";
        g.childNodes[0].onclick = this.onCheckBoxClick;
        this._setSrc(g.childNodes[0], this.imPath + this.checkArray[a.checkstate]);
    }
    else {
        g.style.display = "none";
    }
    g.childNodes[0].treeNod = this;
    this.dragger.removeDraggableItem(c);
    if (this.dragAndDropOff) {
        this.dragger.addDraggableItem(c, this);
    }
    if (this._aimgs) {
        this.dragger.addDraggableItem(g.nextSibling, this);
    }
    c.childNodes[0].className = "standartTreeRow";
    c.parentNode.className = "";
    c.onclick = this.onRowSelect;
    c.ondblclick = this.onRowClick2;
    g.previousSibling.onclick = this.onRowClick;
    this._correctLine(a);
    this._correctPlus(a);
    for (var e = 0; e < a.childsCount; e++) {
        this._clearStyles(a.childNodes[e]);
    }
};
dhtmlXTreeObject.prototype._registerBranch = function (c, a) {
    if (a) {
        a._globalIdStorageSub(c.id);
    }
    c.id = this._globalIdStorageAdd(c.id, c);
    c.treeNod = this;
    for (var e = 0; e < c.childsCount; e++) {
        this._registerBranch(c.childNodes[e], a);
    }
    return 0;
};
dhtmlXTreeObject.prototype.enableThreeStateCheckboxes = function (a) {
    this.tscheck = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.setOnMouseInHandler = function (a) {
    this.ehlt = true;
    this.attachEvent("onMouseIn", a);
};
dhtmlXTreeObject.prototype.setOnMouseOutHandler = function (a) {
    this.ehlt = true;
    this.attachEvent("onMouseOut", a);
};
dhtmlXTreeObject.prototype.enableMercyDrag = function (a) {
    this.dpcpy = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.enableTreeImages = function (a) {
    this.timgen = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.enableFixedMode = function (a) {
    this.hfMode = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.enableCheckBoxes = function (c, a) {
    this.checkBoxOff = dhx4.s2b(c);
    this.cBROf = !(this.checkBoxOff || dhx4.s2b(a));
};
dhtmlXTreeObject.prototype.setStdImages = function (a, e, c) {
    this.imageArray[0] = a;
    this.imageArray[1] = e;
    this.imageArray[2] = c;
};
dhtmlXTreeObject.prototype.enableTreeLines = function (a) {
    this.treeLinesOn = dhx4.s2b(a);
};
dhtmlXTreeObject.prototype.setImageArrays = function (g, a, l, h, e, c) {
    switch (g) {
        case "plus":
            this.plusArray[0] = a;
            this.plusArray[1] = l;
            this.plusArray[2] = h;
            this.plusArray[3] = e;
            this.plusArray[4] = c;
            break;
        case "minus":
            this.minusArray[0] = a;
            this.minusArray[1] = l;
            this.minusArray[2] = h;
            this.minusArray[3] = e;
            this.minusArray[4] = c;
            break;
    }
};
dhtmlXTreeObject.prototype.openItem = function (c) {
    this.skipLock = true;
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return 0;
    }
    else {
        return this._openItem(a);
    }
    this.skipLock = false;
};
dhtmlXTreeObject.prototype._openItem = function (a) {
    var c = this._getOpenState(a);
    if (c < 0 || (this.XMLsource && !a.XMLload)) {
        if (!this.callEvent("onOpenStart", [a.id, c])) {
            return 0;
        }
        this._HideShow(a, 2);
        if (this.checkEvent("onOpenEnd")) {
            if (this.onXLE == this._epnFHe) {
                this._epnFHe(this, a.id, true);
            }
            if (!this.xmlstate || !this.XMLsource) {
                this.callEvent("onOpenEnd", [a.id, this._getOpenState(a)]);
            }
            else {
                this._oie_onXLE.push(this.onXLE);
                this.onXLE = this._epnFHe;
            }
        }
    }
    else {
        if (this._srnd) {
            this._HideShow(a, 2);
        }
    }
    if (a.parentObject && !this._skip_open_parent) {
        this._openItem(a.parentObject);
    }
};
dhtmlXTreeObject.prototype.closeItem = function (c) {
    if (this.rootId == c) {
        return 0;
    }
    this.skipLock = true;
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return 0;
    }
    if (a.closeble) {
        this._HideShow(a, 1);
    }
    this.skipLock = false;
};
dhtmlXTreeObject.prototype.getLevel = function (c) {
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return 0;
    }
    return this._getNodeLevel(a, 0);
};
dhtmlXTreeObject.prototype.setItemCloseable = function (e, a) {
    a = dhx4.s2b(a);
    var c = null;
    if (e && e.span) {
        c = e;
    }
    else {
        c = this._globalIdStorageFind(e);
    }
    if (!c) {
        return 0;
    }
    c.closeble = a;
};
dhtmlXTreeObject.prototype._getNodeLevel = function (a, c) {
    if (a.parentObject) {
        return this._getNodeLevel(a.parentObject, c + 1);
    }
    return c;
};
dhtmlXTreeObject.prototype.hasChildren = function (c) {
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return 0;
    }
    else {
        if (this.XMLsource && !a.XMLload) {
            return true;
        }
        else {
            return a.childsCount;
        }
    }
};
dhtmlXTreeObject.prototype._getLeafCount = function (g) {
    var e = 0;
    for (var c = 0; c < g.childsCount; c++) {
        if (g.childNodes[c].childsCount == 0) {
            e++;
        }
    }
    return e;
};
dhtmlXTreeObject.prototype.setItemText = function (g, e, c) {
    var a = this._globalIdStorageFind(g);
    if (!a) {
        return 0;
    }
    a.label = e;
    a.span.innerHTML = e;
    if (this.childCalc) {
        this._fixChildCountLabel(a);
    }
    a.span.parentNode.parentNode.title = c || "";
};
dhtmlXTreeObject.prototype.getItemTooltip = function (c) {
    var a = this._globalIdStorageFind(c);
    if (!a) {
        return "";
    }
    return (a.span.parentNode.parentNode._dhx_title ||
        a.span.parentNode.parentNode.title ||
        "");
};
dhtmlXTreeObject.prototype.refreshItem = function (c) {
    if (!c) {
        c = this.rootId;
    }
    this._globalIdStorageFind(c);
    this._dynDeleteBranches[c] = (this._dynDeleteBranches[c] || 0) + 1;
    this._loadDynXML(c);
};
dhtmlXTreeObject.prototype.setItemImage2 = function (g, a, h, e) {
    var c = this._globalIdStorageFind(g);
    if (!c) {
        return 0;
    }
    c.images[1] = h;
    c.images[2] = e;
    c.images[0] = a;
    this._correctPlus(c);
};
dhtmlXTreeObject.prototype.setItemImage = function (e, a, g) {
    var c = this._globalIdStorageFind(e);
    if (!c) {
        return 0;
    }
    if (g) {
        c.images[1] = a;
        c.images[2] = g;
    }
    else {
        c.images[0] = a;
    }
    this._correctPlus(c);
};
dhtmlXTreeObject.prototype.getSubItems = function (e) {
    var a = this._globalIdStorageFind(e, 0, 1);
    if (!a) {
        return 0;
    }
    if (a.unParsed) {
        return this._getSubItemsXML(a.unParsed);
    }
    var c = "";
    for (var i = 0; i < a.childsCount; i++) {
        if (!c) {
            c = "" + a.childNodes[i].id;
        }
        else {
            c += this.dlmtr + a.childNodes[i].id;
        }
    }
    return c;
};
dhtmlXTreeObject.prototype._getAllScraggyItems = function (e) {
    var g = "";
    var a = null;
    for (var c = 0; c < e.childsCount; c++) {
        if (e.childNodes[c].unParsed || e.childNodes[c].childsCount > 0) {
            if (e.childNodes[c].unParsed) {
                a = this._getAllScraggyItemsXML(e.childNodes[c].unParsed, 1);
            }
            else {
                a = this._getAllScraggyItems(e.childNodes[c]);
            }
            if (a) {
                if (g) {
                    g += this.dlmtr + a;
                }
                else {
                    g = a;
                }
            }
        }
        else {
            if (!g) {
                g = "" + e.childNodes[c].id;
            }
            else {
                g += this.dlmtr + e.childNodes[c].id;
            }
        }
    }
    return g;
};
dhtmlXTreeObject.prototype._getAllFatItems = function (e) {
    var g = "";
    var a = null;
    for (var c = 0; c < e.childsCount; c++) {
        if (e.childNodes[c].unParsed || e.childNodes[c].childsCount > 0) {
            if (!g) {
                g = "" + e.childNodes[c].id;
            }
            else {
                g += this.dlmtr + e.childNodes[c].id;
            }
            if (e.childNodes[c].unParsed) {
                a = this._getAllFatItemsXML(e.childNodes[c].unParsed, 1);
            }
            else {
                a = this._getAllFatItems(e.childNodes[c]);
            }
            if (a) {
                g += this.dlmtr + a;
            }
        }
    }
    return g;
};
dhtmlXTreeObject.prototype._getAllSubItems = function (l, h, g) {
    if (g) {
        c = g;
    }
    else {
        var c = this._globalIdStorageFind(l);
    }
    if (!c) {
        return 0;
    }
    h = "";
    for (var e = 0; e < c.childsCount; e++) {
        if (!h) {
            h = "" + c.childNodes[e].id;
        }
        else {
            h += this.dlmtr + c.childNodes[e].id;
        }
        var a = this._getAllSubItems(0, h, c.childNodes[e]);
        if (a) {
            h += this.dlmtr + a;
        }
    }
    if (c.unParsed) {
        h = this._getAllSubItemsXML(l, h, c.unParsed);
    }
    return h;
};
dhtmlXTreeObject.prototype.selectItem = function (g, e, c) {
    e = dhx4.s2b(e);
    var a = this._globalIdStorageFind(g);
    if (!a || !a.parentObject) {
        return 0;
    }
    if (this.XMLloadingWarning) {
        a.parentObject.openMe = 1;
    }
    else {
        this._openItem(a.parentObject);
    }
    var h = null;
    if (c) {
        h = new Object();
        h.ctrlKey = true;
        if (a.i_sel) {
            h.skipUnSel = true;
        }
    }
    if (e) {
        this.onRowSelect(h, a.htmlNode.childNodes[0].childNodes[0].childNodes[3], false);
    }
    else {
        this.onRowSelect(h, a.htmlNode.childNodes[0].childNodes[0].childNodes[3], true);
    }
};
dhtmlXTreeObject.prototype.getSelectedItemText = function () {
    var c = new Array();
    for (var a = 0; a < this._selected.length; a++) {
        c[a] = this._selected[a].span.innerHTML;
    }
    return c.join(this.dlmtr);
};
dhtmlXTreeObject.prototype._compressChildList = function (a, e) {
    a--;
    for (var c = 0; c < a; c++) {
        if (e[c] == 0) {
            e[c] = e[c + 1];
            e[c + 1] = 0;
        }
    }
};
dhtmlXTreeObject.prototype._deleteNode = function (m, h, o) {
    if (!h || !h.parentObject) {
        return 0;
    }
    var a = 0;
    var c = 0;
    if (h.tr.nextSibling) {
        a = h.tr.nextSibling.nodem;
    }
    if (h.tr.previousSibling) {
        c = h.tr.previousSibling.nodem;
    }
    var l = h.parentObject;
    var e = l.childsCount;
    var n = l.childNodes;
    for (var g = 0; g < e; g++) {
        if (n[g].id == m) {
            if (!o) {
                l.htmlNode.childNodes[0].removeChild(n[g].tr);
            }
            n[g] = 0;
            break;
        }
    }
    this._compressChildList(e, n);
    if (!o) {
        l.childsCount--;
    }
    if (a) {
        this._correctPlus(a);
        this._correctLine(a);
    }
    if (c) {
        this._correctPlus(c);
        this._correctLine(c);
    }
    if (this.tscheck) {
        this._correctCheckStates(l);
    }
    if (!o) {
        this._globalIdStorageRecSub(h);
    }
};
dhtmlXTreeObject.prototype.setCheck = function (e, c) {
    var a = this._globalIdStorageFind(e, 0, 1);
    if (!a) {
        return;
    }
    if (c === "unsure") {
        this._setCheck(a, c);
    }
    else {
        c = dhx4.s2b(c);
        if (this.tscheck && this.smcheck) {
            this._setSubChecked(c, a);
        }
        else {
            this._setCheck(a, c);
        }
    }
    if (this.smcheck) {
        this._correctCheckStates(a.parentObject);
    }
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeObject/dxTreeObjectMethods0.js